import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toCount } from './values';

export function nightRange(query: QueryObject): Pick<SearchCriteriaParams, 'nightRange'> | null {
  const from = toCount(query.nightFrom);
  const to = toCount(query.nightTo);

  return from && to ? { nightRange: { from, to } } : null;
}
